import React from "react";
import { MixtureTabItemStyled } from "./MixtureTabItemStyled";
import { MixtureTabItemProps } from "../../../entities/Mixture";

const MixtureTabItem: React.FC<MixtureTabItemProps> = ({
  name,
  image,
}: MixtureTabItemProps) => {
  const parsedImage = image && JSON.parse(image) ? JSON.parse(image)[0] : "";
  return (
    <MixtureTabItemStyled>
      <div className="mixture-item__name">{name}</div>
      <div className="mixture-item__photo">
        <img src={parsedImage} alt={name} />
      </div>
    </MixtureTabItemStyled>
  );
};

export default MixtureTabItem;
